import type { TileImage, Variation } from '@shared/types/types.ts';

const EMPTY_IMAGE: TileImage = { id: '', alt: '', fallback: '', jpeg: '', webp: '' };

export type LayoutImageIntents = {
    cutoutActive: boolean;
    multipleImagesActive: boolean;
};

function statusQuo(rawImages: TileImage[]): { images: TileImage[]; primaryImage: TileImage } {
    const images = rawImages.slice(0, 3);
    const first = images[0];
    return { images, primaryImage: first !== undefined ? first : EMPTY_IMAGE };
}

export function getLayoutImages(
    variation: Variation,
    intents?: LayoutImageIntents,
): { images: TileImage[]; primaryImage: TileImage } {
    const rawImages = variation.images;

    if (!intents?.cutoutActive || !variation.cutout?.id) {
        return statusQuo(rawImages);
    }

    const cutout = variation.cutout;

    if (!intents.multipleImagesActive) {
        return { images: statusQuo(rawImages).images, primaryImage: cutout };
    }

    const images = [cutout, ...rawImages.filter((img) => img.id !== cutout.id)].slice(0, 3);
    return { images, primaryImage: cutout };
}
